export default __webpack_public_path__ + "static/Arla_White-b4f1983de1a5c851b3a2e7f802ac6c64.svg";